import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Card, CardBody, Col, Row, Spinner } from 'reactstrap'
import { Statistic } from 'antd'
import moment from 'moment'

import TaskResponsesUserTobBar from './partials/TaskResponsesUserTobBar'
import TaskReponsesUserTable from './partials/TaskReponsesUserTable'

import { getTaskResponsesUserReport } from './services'
import { handleError, round } from '../../helpers'

export default function TaskResponsesUserReport() {
	const user = useSelector(state => state.auth.user)
	const [report, setReport] = useState(null)
	const [params, setParams] = useState({
		from: moment().startOf('month'),
		to: moment().endOf('month'),
		user_id: user.id,
		user_name: user.name,
	})

	useEffect(() => {
		!report && getTaskResponsesUserReport({
			...params,
			from: params.from.format('YYYY-MM-DD') + ' 00:00:00',
			to: params.to.format('YYYY-MM-DD') + ' 23:59:59',
		})
			.then(res => setReport(res.data.data))
			.catch(error => handleError(error))
	}, [ report, params ])

	const statCards = report ? [
		{
			title: "Total de Visitas",
			value: report.stats.completed_visits_count,
			suffix: "completadas"
		},
		{
			title: "Total de Visitas con Checklist",
			value: report.stats.completed_with_task_reponses,
			suffix: report.stats.completed_with_task_reponses > 1 ? 'visitas' : 'visita',
		},
		{
			title: "Tasa de Visitas Efectivas",
			value: report.stats.completed_with_task_reponses ? `${round(report.stats.completed_with_task_reponses/report.stats.completed_visits_count*100)}%` : '0%',
		},
		{
			title: "Número de tiendas asociadas",
			value: report.stats.unique_store_count,
			suffix: "tiendas"
		},
		{
			title: "Prom. Visitas por tienda",
			value: report.stats.unique_store_count ? `${round(report.stats.completed_visits_count/report.stats.unique_store_count)}` : '0',
			suffix: "visitas"
		},
		{
			title: "Tienda con mayor cantidad de visitas",
			value: report.stats.store_name_with_most_visits,
			dobleWidth: true,
		},
	] : []

	return (
		<React.Fragment>
			<TaskResponsesUserTobBar 
				params={params}
				setParams={setParams}
				reload={() => setReport(null)}
			/>
			<Row>
				<Col xs="6" md="3">
					<Card>
						<CardBody>
							{ report && (
								<Statistic 
									title={report.params.user_name} 
									suffix={`${moment(report.params.from).format('DD MMM YY')} al ${moment(report.params.to).format('DD MMM YY')}`}
									value="Tareas"
								/>
							)}
						</CardBody>
					</Card>
				</Col>
				{ report ? statCards.map( (stat,i) => (
					<Col xs="6" md={stat.dobleWidth ? 6 : 3} key={i}>
						<Card>
							<CardBody>
								<Statistic {...stat} />
							</CardBody>
						</Card>
					</Col>
				)) : (
					<Col className="text-center mt-2 mb-4">
						<Spinner size="sm" />
					</Col>
				)}
			</Row>
			<Card>
				<CardBody>
					{ report ? (
						<TaskReponsesUserTable 
							data={report.tables.task_responses}
						/>
					) : <Spinner />}
				</CardBody>
			</Card>
		</React.Fragment>
	)
}